import WechatJSSDK from "wechat-jssdk/dist/client.umd";
import { getWechatConfig, wechatAuth } from "@api/public";
import { parseQuery } from "@utils";
import cookie from "@utils/store/cookie";
import store from "@/store";
const STATE_KEY = "wx_authorize_state";
const WX_AUTH = "wx_auth";
const BACK_URL = "login_back_url";
const LOGINTYPE = "loginType";
let instance;
let wechatObj;
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";

const WECHAT_SCRIPT_URL = "//res.wx.qq.com/open/js/jweixin-1.6.0.js";

export default function wechat() {
    return new Promise((resolve, reject) => {
        if (instance && instance.initConfig) return resolve(instance);
        getWechatConfig()
            .then(res => {
                res.data.customUrl = WECHAT_SCRIPT_URL;
                const _wx = WechatJSSDK(res.data);
                wechatObj = _wx;
                _wx
                    .initialize()
                    .then(() => {
                        instance = _wx.wx;
                        instance.initConfig = res.data;
                        resolve(instance);
                    })
                    .catch(reject);
            })
            .catch(err => {
                console.log(err);
                reject(err);
            });
    });
}

export function clearAuthStatus() {
    localStorage.removeItem(WX_AUTH);
    localStorage.removeItem(STATE_KEY);
}

export function oAuth() {
    const token = store.state.app.token;
    const expiresTime = localStorage.getItem('expires');
    const wxAuth = localStorage.getItem(WX_AUTH);
    const now = new Date().getTime();
    
    console.log('【授权检查】当前状态:', {
        hasToken: !!token,
        hasWxAuth: !!wxAuth,
        expiresTime: expiresTime,
        isExpired: expiresTime ? now >= parseInt(expiresTime) : 'unknown',
        currentTime: now
    });
    
    // 检查token是否存在且未过期
    if (token && expiresTime && now < parseInt(expiresTime)) {
        console.log('【授权检查】token有效，无需重新授权');
        return Promise.resolve();
    }
    
    // token已过期，清除旧的授权信息
    if (token && (!expiresTime || now >= parseInt(expiresTime))) {
        console.log('【授权检查】token已过期，清理授权信息');
        clearAuthStatus();
        store.commit('LOGOUT');
    }
    
    // 检查URL中是否有code
    const { code } = parseQuery();
    console.log('【授权检查】URL中的code:', code);
    
    if (!code) {
        // 没有code，需要跳转授权
        console.log('【授权检查】无code，跳转微信授权');
        localStorage.setItem(BACK_URL, location.pathname + location.search);
        return toAuth();
    }
    
    // 有code但没有有效token，用code换取token
    console.log('【授权检查】使用code换取token');
    return auth(code).catch(err => {
        console.error('【授权检查】换取token失败:', err);
        // 授权失败，清除code重新授权
        clearAuthStatus();
        localStorage.removeItem(WX_AUTH);
        return toAuth();
    });
}

export function auth(code) {
    return new Promise((resolve, reject) => {
        let loginType = localStorage.getItem(LOGINTYPE);
        const spread = parseInt(localStorage.getItem("spread")) || 0;
        
        console.log('【授权换取】开始用code换取token:', { code: code ? code.substring(0, 10) + '...' : null, loginType, spread });
        
        //if (state !== localStorage.getItem(STATE_KEY)) return reject();
        wechatAuth(code, spread, loginType)
            .then((res) => {
                console.log('【授权换取】成功获取授权信息');
                
                if (res.status === 200 && res.data) {
                    const data = res.data;
                    
                    // 处理过期时间
                    let expires_time = data.expires_time;
                    if (expires_time) {
                        expires_time = expires_time.substring(0, 19);
                        expires_time = expires_time.replace(/-/g, "/");
                        expires_time = new Date(expires_time).getTime() - 28800000;
                    }
                    
                    // 保存token到store和localStorage
                    const authData = {
                        token: data.token,
                        expires_time: expires_time,
                    };
                    
                    store.commit("LOGIN", authData);
                    localStorage.setItem('baoshi_user_token', data.token);
                    localStorage.setItem(WX_AUTH, code);
                    
                    // 保存用户信息（如果有）
                    if (data.userinfo) {
                        localStorage.setItem("USERINFO", JSON.stringify(data.userinfo));
                    }
                    
                    console.log('【授权换取】授权信息已保存到本地');
                }
                
                resolve(res);
            })
            .catch((err) => {
                console.error('【授权换取】换取token失败:', err);
                reject(err);
            });
    });
}

export function toAuth() {
    wechat().then(wx => {
        if (wx) {
            let { appId } = wx.initConfig || {appId: 'wx7524efcc228f437b'}
            location.href = getAuthUrl(appId);
        }
    });
}

function getAuthUrl(appId = 'wx7524efcc228f437b') {
    const redirect_uri = encodeURIComponent(
        `${location.origin}/auth/` +
        encodeURIComponent(
            encodeURIComponent(
                localStorage.getItem(BACK_URL) || (location.pathname + location.search)
            )
        )
    );
    localStorage.removeItem(BACK_URL);
    const state = encodeURIComponent(
        ("" + Math.random()).split(".")[1] + "authorizestate"
    );
    localStorage.setItem(STATE_KEY, state);
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
}

function toPromise(fn, config = {}) {
    return new Promise((resolve, reject) => {
        fn({
            ...config,
            success(res) {
                resolve(res);
            },
            fail(err) {
                reject(err);
            },
            complete(err) {
                reject(err);
            },
            cancel(err) {
                reject(err);
            }
        });
    });
}

export function pay(config) {
    return toPromise(instance.chooseWXPay, config);
}

export function openAddress() {
    return new Promise((resolve, reject) => {
        wechatEvevt("openAddress", {})
            .then(res => {
                resolve(res);
            })
            .catch(res => {
                if (res.is_ready) {
                    res.wx.openAddress({
                        fail(res) {
                            reject(res);
                        },
                        success(res) {
                            resolve(res);
                        }
                    });
                } else {
                    reject(res);
                }
            });
    });
}

export async function openShareAll(config) {
    config || {};
    config.type = config.type == undefined ? "link" : config.type;
    await wechat();
    return new Promise(resolve => {
        getWechatConfig().then(res => {
            wechatObj.signSignature({
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
                timestamp: res.data.timestamp
            });
            instance = wechatObj.getOriginalWx();
            instance.ready(() => {
                instance.updateAppMessageShareData(config);
                instance.updateTimelineShareData(config);
                resolve();
            });
        });
    });
}

export function openShareAppMessage(config) {
    instance.updateAppMessageShareData(config);
    instance.onMenuShareAppMessage && instance.onMenuShareAppMessage(config);
}

export function openShareTimeline(config) {
    instance.updateTimelineShareData(config);
    instance.onMenuShareTimeline && instance.onMenuShareTimeline(config);
}

/**
 * 公众号事件
 * @param name 事件名
 * @param config 配置
 * @returns {Promise<unknown>}
 */
export function wechatEvevt(name, config) {
    return new Promise((resolve, reject) => {
        let wx;
        let configDefault = {
            fail(res) {
                console.log(res);
                if (wx) return reject({ is_ready: true, wx: wx });
                getWechatConfig().then(res => {
                    wechatObj.signSignature({
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        timestamp: res.data.timestamp
                    });
                    wx = wechatObj.getOriginalWx();
                    reject({ is_ready: true, wx: wx });
                });
            },
            success(res) {
                resolve(res);
                console.log("success=>", res)
            },
            cancel(err) {
                reject(err);
                console.log("123123123=>", err)
            },
            complete(err) {
                reject(err);
            }
        };
        Object.assign(configDefault, config);
        getWechatConfig().then(res => {
            const _wx = WechatJSSDK(res.data);
            _wx.initialize().then(() => {
                instance = _wx.getOriginalWx();
                instance.ready(() => {
                    if (typeof name === "object") {
                        name.forEach(item => {
                            instance[item] && instance[item](configDefault);
                        });
                    } else instance[name] && instance[name](configDefault);
                });
            });
        });
    });
}

export function ready() {
    return new Promise(resolve => {
        if (typeof instance !== "undefined") {
            instance.ready(() => {
                resolve(instance);
            });
        } else {
            getWechatConfig().then(res => {
                const _wx = WechatJSSDK(res.data);
                _wx.initialize().then(() => {
                    instance = _wx.wx;
                    instance.ready(() => {
                        resolve(instance);
                    });
                });
            });
        }
    });
}

export function wxShowLocation() {
    return new Promise((resolve, reject) => {
        let longitude = localStorage.getItem(LONGITUDE); //经度
        let latitude = localStorage.getItem(LATITUDE); //纬度
        if (longitude && latitude) {
            return resolve({ longitude: longitude, latitude: latitude });
        }
        wechatEvevt("getLocation", { type: "wgs84" })
            .then(res => {
                let latitude = res.latitude; // 纬度
                let longitude = res.longitude; // 经度
                localStorage.setItem(LATITUDE, latitude);
                localStorage.setItem(LONGITUDE, longitude);
                resolve(res);
            })
            .catch(res => {
                localStorage.removeItem(LATITUDE);
                localStorage.removeItem(LONGITUDE);
                reject(res);
                if (res.is_ready) {
                    res.wx.getLocation({
                        success(res) {
                            let latitude = res.latitude; // 纬度
                            let longitude = res.longitude; // 经度
                            localStorage.setItem(LATITUDE, latitude);
                            localStorage.setItem(LONGITUDE, longitude);
                            resolve(res);
                        },
                        cancel(res) {
                            localStorage.removeItem(LATITUDE);
                            localStorage.removeItem(LONGITUDE);
                            reject(res);
                        },
                        fail(res) {
                            localStorage.removeItem(LATITUDE);
                            localStorage.removeItem(LONGITUDE);
                            reject(res);
                        }
                    });
                } else {
                    localStorage.removeItem(LATITUDE);
                    localStorage.removeItem(LONGITUDE);
                    reject(res);
                }
            })
            .fail(error => {
                reject(error);
            });
    });
}